module.exports = __webpack_public_path__ + "img/courier-ups.d6381c79.svg";